import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
// import GridContainer from '@components/GridContainer';
import classNames from 'classnames';
import { Sidebar } from '@/components/Sidebar/Sidebar';
import { Field, PageConfig } from '@/types';
import { MobileNavbar } from '@/components/Navbar/MobileNavbar';
import { EnergyReport } from '@/components/EnergyReport';

export interface CategoryItem {
  name: string;
  category: string;
  qns: Field[];
}
interface Props {
  className?: string;
  page?: string;
  pages?: PageConfig[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form?: Record<string, any>;
  isFetched?: boolean;
  uuid?: string;
  upsertLoading?: boolean;
}

const MainContainer: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  page,
  pages,
  form,
  isFetched = false,
  uuid,
  upsertLoading = false,
}) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 800);
    return () => clearTimeout(timer);
  }, [page]);

  function getUniqueCategories(array: CategoryItem[]): { category: string; name: string; qns: Field[] }[] {
    const uniqueCategories = [...new Set(array.map(item => item.category))];

    return uniqueCategories.map(category => {
      const item = array.find(item => item.category === category);
      return {
        category,
        name: item?.name || '',
        qns: item?.qns || [],
      };
    });
  }

  const sidenav = getUniqueCategories(pages ?? []);

  const shouldShowEnergyReport = isFetched;
  return (
    <div className="bg-primary min-h-screen flex flex-col md:flex-row">
      {' '}
      {/* Use flex on the root container */}
      {/* Fixed Sidebar */}
      <div className="block xl:hidden fixed top-0 w-full z-[10]">
        <MobileNavbar page={page ?? ''} pages={sidenav ?? []} formValues={form ?? {}} />
      </div>
      <div className="hidden xl:block fixed left-0 top-0 h-full min-w-[360px]">
        {' '}
        {/* Ensure sidebar itself can scroll if its content overflows */}
        <Sidebar isFetched={shouldShowEnergyReport} page={page} pages={sidenav ?? []} formValues={form ?? {}} />
      </div>
      {/* Main Content Area */}
      <div
        className={classNames(
          `flex-1 ${shouldShowEnergyReport ? 'xl:ml-[380px]' : 'xl:ml-[120px]'} py-8 px-4 relative max-w-[100vw] overflow-x-hidden`,
          {
            /* Add margin-left to push content past sidebar */ [className!]: className,
          },
        )}
      >
        <div
          className={classNames(`${shouldShowEnergyReport ? '' : 'max-w-[680px]'} mx-auto space-y-6 mb-8`, {
            'animate-fade-in': animate,
          })}
        >
          {' '}
          {/* Center content within its available space */}
          {shouldShowEnergyReport ? <EnergyReport uuid={uuid ?? ''} upsertLoading={upsertLoading} /> : children}
        </div>
      </div>
    </div>
  );
};

export default MainContainer;
